import axios from "axios";
import authHeader from '../../../authheader'

const PLSAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsReinstatement";



const getBoardRecommendations = (reinstatementId) => {
    return axios.get(`${PLSAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { reinstatementId } });
}
const getBoardResponses = (reinstatementId) => {
    return axios.get(`${PLSAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { reinstatementId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${PLSAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}